const projects = [
    {
        title: 'MicroPortal',
        category: 'Educator platform',
        date: 'May 2025 - Present',
        desc: 'A personalized platform for MicroSociety® educators, featuring resources tailored to their needs.',
        tech: 'Next.js · React · TypeScript · Tailwind CSS · Vercel · Supabase',
        featured: true,
        artwork: 'portal',
    },
    {
        title: 'Personal Portfolio Website',
        category: 'Design & development',
        date: 'May 2021 - Present',
        desc: 'My handcrafted portfolio showcasing projects, skills, and design sense. Built for responsiveness, clarity, and personal flair✨.',
        tech: 'React · Tailwind CSS · Vercel',
        featured: true,
        artwork: 'portfolio',
    },
    {
        title: 'Hues & Cues: Expanded',
        category: 'Multiplayer game',
        date: 'August 2026 - Present',
        desc: 'A real-time multiplayer color guessing game with creative clues, thousands of colors, and friendly competition. Built for colorful chaos, quick thinking, and fun with friends!',
        tech: 'Next.js · React · TypeScript · Tailwind CSS · Supabase · PostgreSQL · Vercel',
        artwork: 'hues',
    },
    {
        title: 'Little LilyPad',
        category: 'Nature & learning',
        date: 'May 2026 - Present',
        desc: 'A cozy site for curious plant lovers! Explore flowers, discover fun facts, and learn a little more about the greenery around us.',
        tech: 'Next.js · React · TypeScript · Tailwind CSS · Vercel',
        artwork: 'lilypad',
    },
    {
        title: 'MicroExpress',
        category: 'Educational technology',
        date: 'November 2025 - Present',
        desc: 'A playful, interactive learning platform where students explore careers, build real-world skills, and learn by doing. Bringing lessons to life through storytelling, hands-on challenges, and a little imagination!',
        tech: 'Next.js · React · TypeScript · Tailwind CSS · Vercel · AWS',
        artwork: 'express',
    },
    {
        title: '4th Terra®',
        category: '3D simulation',
        date: 'June 2024 - Present',
        desc: 'A 3D classroom simulation where students build a just and thriving society through business creation and collaborative gameplay.',
        tech: 'Unity · C#',
        artwork: 'terra',
    },
    {
        title: 'LogicYAP',
        category: 'Interactive learning',
        date: 'Feb 2024 - Present',
        desc: 'A proof-solving tool and concept explainer for symbolic logic students. Features an interactive solver and responsive design.',
        tech: 'React · Tailwind CSS · Vercel',
        artwork: 'logic',
    },
    {
        title: 'MicroSociety Official Site',
        category: 'Web design & accessibility',
        date: 'Jan 2024 - Present',
        desc: "Redesigned and maintained MicroSociety's main WordPress site with custom blocks, improved accessibility, and responsive design.",
        tech: 'WordPress · Pantheon · DDEV · PHP · ACF',
        artwork: 'website',
    },

    {
        title: 'Varia Lingua',
        category: 'Language & culture',
        date: 'Dec 2023',
        desc: 'A deep dive into African Englishes through an interactive site exploring linguistic and cultural variation across Nigeria, Kenya, and Cameroon.',
        tech: 'React · Vercel',
        artwork: 'language',
    },
    {
        title: 'JobMapr Plus',
        category: 'Data & AI',
        date: 'Oct 2023 - Jun 2024',
        desc: 'A job market insight tool that scrapes Indeed.com and visualizes data by city, skill, salary, and category with smart LLM-powered features.',
        tech: 'React · Next.js · Python · BART · AWS',
        artwork: 'jobs',
    },
    {
        title: 'MicroSociety® 2.0',
        category: 'Learning ecosystem',
        date: 'April 2023 - Present',
        desc: 'A digital ecosystem for student-run societies that simulates real-world systems like government, jobs, and banking within classrooms.',
        tech: 'Google Sites · PHP · Laravel · MySQL · React · Next.js · TypeScript · AWS',
        artwork: 'society',
    },
    {
        title: 'NotaBene',
        category: 'Productivity',
        date: 'Dec 2022 - Present',
        desc: 'A minimalist note and task-tracking tool built for clarity, speed, and organization.',
        tech: 'HTML · CSS · JavaScript · AWS',
        artwork: 'notes',
    },
    {
        title: 'Project Lively',
        category: 'Music & discovery',
        date: 'Dec 2022',
        desc: 'Matches your Spotify music taste with upcoming concerts and nearby hotels using Spotify and Ticketmaster APIs.',
        tech: 'HTML · CSS · JavaScript',
        artwork: 'music',
    },
    {
        title: 'Focus, Study, Concentrate',
        category: 'Study tools',
        date: 'Jan - Jun 2021',
        desc: 'A collaborative study aid tool with quiz generators and scheduling features built as an MVP with a small team.',
        tech: 'HTML · CSS · JavaScript',
        artwork: 'focus',
    },
]

export default projects
